export default __webpack_public_path__ + "static/media/performance-tracking-icon.25e7c8a0.svg";